<template>
  <div :class="{last: isLast}" class="progress-item">
    <label><span
      v-text="chartLabel"></span>:
      <span>
                {{ decimalize(value) }}  /&nbsp;{{ total }}{{ unit }}
                </span>
    </label>
    <mu-linear-progress
      :color="barMode === 'indeterminate' ? `rgba(${color}, 0.24)`: color"
      :mode="barMode"
      :size="16"
      :value="(value) ? ((value / total) > 100 ? 100 : (value / total) * 100) : 0"
    ></mu-linear-progress>
  </div>
</template>

<script>
import FoodDiaryNutritionMixin from "../../../../mixins/FoodDiaryNutritionMixin"

export default {
  name: "ProgressItem",
  mixins: [FoodDiaryNutritionMixin],
  props: {
    barMode: {
      type: String, default() {
        return "indeterminate"
      }
    },
    value: Number,
    total: Number,
    color: String,
    unit: {
      type: String,
      default() {
        return 'g'
      }
    },
    isLast: {
      type: Boolean,
      default() {
        return false;
      }
    },
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    chartLabel() {
      switch
        (this.label.toLowerCase()) {
        case "carbs":
          return this.$t('message.nutrientCarbohydrateShort');
        case "fat":
          return this.$t('message.nutrientFat');
        case "protein":
          return this.$t('message.nutrientProtein');
        default:
          return this.label;
      }
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ProgressItem.vue?49454faf